<template>
  <div>
    <h4 class="tab_style">{{ $t("password") }}</h4>
    <p class="tab_style_sub_tekst">{{ $t("password_data") }}</p>
    <v-divider class="mb-4"></v-divider>

    <v-card elevation="0">
      <v-card-text class="pa-0">
        <v-form v-model="valid">
          <text-field
            v-model="newPassword"
            :label="$t('enter_new_password')"
            name="newPassword"
            prepend-inner-icon="mdi-lock"
            type="password"
            :rules="[rules.required, rules.password]"
          ></text-field>

          <text-field
            v-model="confirmPassword"
            :label="$t('confirm_new_pass')"
            name="newPasswordCheck"
            prepend-inner-icon="mdi-lock"
            type="password"
            :rules="[rules.required, rules.repeatPassword(confirmPassword, newPassword)]"
          ></text-field>

          <text-field
            v-model="currentPassword"
            :label="$t('enter_your_password')"
            name="currPassword"
            prepend-inner-icon="mdi-lock"
            type="password"
            :rules="[rules.required]"
          ></text-field>

          <v-alert dense outlined type="error" v-if="incorrectPassword" class="mb-4">
            {{ $t("incorrect_password") }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-0">
        <primary-button @click="handlePasswordChange" block :disabled="!valid">
          {{ $t("confirm_pass_change") }}
        </primary-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";

export default {
  name: "ProfilePasswordChange",
  mixins: [hasValidation, hasSnackbar],
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      newPassword: null,
      confirmPassword: null,
      currentPassword: null,
      passwordMismatch: false,
      incorrectPassword: false,
    };
  },
  methods: {
    async handlePasswordChange() {
      this.passwordMismatch = false;
      this.incorrectPassword = false;

      // Check if passwords match
      if (this.newPassword !== this.confirmPassword) {
        this.passwordMismatch = true;
        return;
      }

      try {
        await userService.changePassword(
          this.userId,
          this.currentPassword,
          this.newPassword
        );

        // Clear form
        this.newPassword = null;
        this.confirmPassword = null;
        this.currentPassword = null;

        this.showSuccessSnackbar(this.$t("password_changed"));
        this.$emit("password-changed");
      } catch (error) {
        this.incorrectPassword = true;
        this.showErrorSnackbar(this.$t("error_changing_password"));
      }
    },
  },
};
</script>

<style scoped>
.tab_style {
  font-size: 18px;
  font-family: "Poppins", Helvetica, sans-serif;
}

.tab_style_sub_tekst {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.55);
}
</style>
